
import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import Popup from '@/components/utils/Popup.vue';
import { Room, RoomSpace } from '@/utils/models';
import { DefaultDatePickerLangSettings } from '@/utils/constants';

@Component({ components: { Popup } })
export default class LogPopup extends Vue {
  @Prop() room!: Room;

  logDateRange: Date[] = [];
  //#region datepicker settings
  datePickerLang = DefaultDatePickerLangSettings;
  defaultValue = new Date(); // mounted で一か月後を指定
  disabledDate = (date: Date, currentValue: Date[]) => {
    return date.getTime() > Date.now();
  };
  //#endregion
  mounted() {
    const now = new Date();
    this.defaultValue = new Date(now.getFullYear(), now.getMonth() - 1, 1);
  }
  onConfirm(): void {
    this.requestRoomLogs();
  }

  hidePopup(): void {
    this.$emit('close');
  }
  @Emit()
  requestRoomLogs() {
    return {
      roomId: this.room.id,
      range: this.logDateRange,
    };
  }
}
